export default {
      id: "plate-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#plate",
      toString: function () {
        return this.url;
      }
    }